//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.StructureDesign.js";
import "../Features/Features.StructureDesign.FeatureParmsBuilder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
let d=[[[0,"BoundaryCurve",0,"ScCollector",0],[1,"Height",0,"Expression",0],[0,"InputMode0",1,0],[0,"InputMode1",1,0],[0,"InputMode2",1,0],[1,"Length",0,"Expression",0],[0,"Point0",1,"Point",0],[1,"Point0X",0,"Expression",0],[1,"Point0Y",0,"Expression",0],[1,"Point0Z",0,"Expression",0],[0,"Point1",1,"Point",0],[1,"Point1X",0,"Expression",0],[1,"Point1Y",0,"Expression",0],[0,"Point2",1,"Point",0],[1,"Point2Z",0,"Expression",0],[0,"SplitCurve",0,"ScCollector",0],[1,"Width",0,"Expression",0]],[[["sourceCurves","actionType","actionDirection","actionDistance"],"AddAction",{},4,0],[[],"UndoAction",{},0,0],[[],"CreateCurves",{},0,0],[["curveTag"],"CopyCurve",{R_:{copiedCurveTag:"Curve"}},1,0],[["curveTag","startPoint","endPoint"],"UpdateCurve",{},3,0],[["curveTag"],"DeleteCurve",{},1,0],[["curveTag"],"ReparentAndDeleteCurve",{},1,0]],[]];
SPLM.Features.StructureDesign.SuperFrameBuilder = class extends SPLM.Features.StructureDesign.FeatureParmsBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.StructureDesign.SuperFrameBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.StructureDesign.SuperFrameBuilder.TransformTypes = Object.freeze({
    "Move" : "Move", "Copy" : "Copy", "Split" : "Split", "Delete" : "Delete", "None" : "None"});

SPLM.Features.StructureDesign.SuperFrameBuilder.InputModes = Object.freeze({
    "Coordinates" : "Coordinates", "Parameters" : "Parameters"});

SPLM.Features.StructureDesign.SuperFrameBuilder.BaseTypes = Object.freeze({
    "None" : "None", "Corners" : "Corners", "Transform" : "Transform"});

export default SPLM;